<template>
  <button
    class="o-button"
    @click.prevent.stop="sync"
  >
    <i
      class="o-icon o-button__icon"
      :class="iconClasses"
    ></i>
    <span
      v-if="showLabel"
      class="o-typography__label o-button__label"
    >
      {{ $t('glossary.myList') }}
    </span>
  </button>
</template>
<script>
  import { RouteName } from '@/shared/enums';

  export default {
    props: {
      product: Object,
      showLabel: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isLoading: false,
        subscriber: this.$services.resolve('subscriber'),
        favourites: this.$services.resolve('favourites'),
      };
    },
    computed: {
      iconClasses() {
        if (this.isLoading) {
          return 'o-icon--buffering u-spinner-animation';
        }
        return this.product.favourite ? 'o-icon--my-list-fill' : 'o-icon--my-list';
      },
    },
    mounted() {
      if ([RouteName.DETAIL, RouteName.DETAIL_WITH_ARTICLE].includes(this.$route.name)
        && this.$route.query.favourite
        && !this.product.favourite) {
        this.sync();
      }
    },
    methods: {
      async sync() {
        if (this.isLoading) {
          return;
        }

        if (!this.subscriber.isLogged) {
          return this.$router.push({ name: RouteName.SUBSCRIBER_LOGIN, query: { redirect: this.$route.fullPath } });
        }

        const method = this.product.favourite ? 'remove' : 'create';
        this.isLoading = true;

        await this.favourites[method](this.product, { sync: true });
        // manually updating favourite flag as sdk helper is not working correctly with continue watching and favourites sections
        this.product.favourite = method === 'create';

        if (this.product.favourite) {
          this.$stats.addToFavorites(this.product);
        }

        this.isLoading = false;
      },
    },
  };
</script>
